export default "__VITE_ASSET__7beb7003__"